import { SNAP_POINTS, SnapPoint } from "@constants/Drawer";

export function set(
  element: HTMLElement | null,
  styles: Partial<CSSStyleDeclaration>
) {
  if (!element) return;
  Object.assign(element.style, styles);
}

export const findNearestSnapPoint = (value: number): SnapPoint => {
  let nearest: SnapPoint = SNAP_POINTS[0];
  let minDiff = Infinity;

  SNAP_POINTS.forEach(p => {
    const diff = Math.abs(p - value);
    if (diff < minDiff) {
      minDiff = diff;
      nearest = p;
    }
  });

  return nearest;
};
